import React from 'react';
export function VideoIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-179">
      <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" data-id="element-180" />
      <line x1="7" y1="2" x2="7" y2="22" data-id="element-181" />
      <line x1="17" y1="2" x2="17" y2="22" data-id="element-182" />
      <line x1="2" y1="12" x2="22" y2="12" data-id="element-183" />
      <line x1="2" y1="7" x2="7" y2="7" data-id="element-184" />
      <line x1="2" y1="17" x2="7" y2="17" data-id="element-185" />
      <line x1="17" y1="17" x2="22" y2="17" data-id="element-186" />
      <line x1="17" y1="7" x2="22" y2="7" data-id="element-187" />
    </svg>;
}